import { connect } from 'react-redux'
import {
  setCurrentSearchPhrase,
  setSearchResponse,
  setSearchState
} from 'redux/actions'
import Paged from 'pages/search/Paged'

const mapDispatchToProps = dispatch => ({
  setSearchState: (props) => dispatch(setSearchState(props)),
  setSearchResponse: response => dispatch(setSearchResponse(response)),
  setCurrentSearchPhrase: searchPhrase => dispatch(setCurrentSearchPhrase(searchPhrase))
})

export default connect(null, mapDispatchToProps)(Paged)
